import { render, staticRenderFns } from "./realTime.vue?vue&type=template&id=f52e2cea&scoped=true&"
import script from "./realTime.vue?vue&type=script&lang=js&"
export * from "./realTime.vue?vue&type=script&lang=js&"
import style0 from "./realTime.vue?vue&type=style&index=0&id=f52e2cea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52e2cea",
  null
  
)

export default component.exports